const experiencePackages = [
  {
    type: 'hot',
    label: '限时体验',
    name: '9.9元体验包',
    price: '9.9',
    features: [
      '订仓单×1',
      '草单×1',
      '不含申报提交',
      '限购1次/户',
      '30天内使用'
    ]
  },
  {
    type: 'hot',
    label: '限时体验',
    name: '99元完整体验',
    price: '99',
    features: [
      '订仓单×1',
      '草单×1',
      '申报提交',
      '限购1次/户',
      '30天内使用'
    ]
  },
  {
    type: 'tool',
    label: '按需购买',
    name: 'AI归类工具',
    price: '按SPU计费',
    features: [
      '智能商品归类',
      '海关编码推荐',
      '合规性检查',
      '即买即用',
      '无使用期限'
    ]
  },
  {
    type: 'tool',
    label: '按需购买',
    name: '全套餐次数包',
    price: '咨询定价',
    features: [
      '含申报回执回传',
      '不含专家审阅',
      '不含值守服务',
      '灵活购买次数',
      '有效期内使用'
    ]
  }
];

export default function Experience() {
  const openConsultation = () => {
    const drawer = document.getElementById('consultation-drawer');
    if (drawer) drawer.classList.remove('translate-x-full');
  };

  return (
    <section id="experience" className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            先用低成本跑通一票，再决定订阅
          </h2>
          <p className="text-gray-600 text-lg">
            零风险体验完整流程，适合首次尝试的卖家
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {experiencePackages.map((pkg, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="p-8">
                <div
                  className={`inline-block px-4 py-1 rounded-full text-xs font-bold mb-4 ${
                    pkg.type === 'hot'
                      ? 'bg-orange-100 text-orange-600'
                      : 'bg-blue-100 text-blue-600'
                  }`}
                >
                  {pkg.label}
                </div>

                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {pkg.name}
                </h3>

                <div className="mb-6">
                  <span className="text-4xl font-bold text-[#FF6B35]">
                    {pkg.price}
                  </span>
                  {pkg.price !== '按SPU计费' && pkg.price !== '咨询定价' && (
                    <span className="text-gray-500 ml-1">元</span>
                  )}
                </div>

                <ul className="space-y-2 mb-6">
                  {pkg.features.map((feature, fIndex) => (
                    <li key={fIndex} className="text-sm text-gray-600 flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#14B8A6] flex-shrink-0 mt-0.5"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={openConsultation}
                  className="w-full h-11 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-medium rounded-full hover:scale-105 transition-transform whitespace-nowrap cursor-pointer"
                >
                  立即购买
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
